import { Component, input, output } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'ia-market-scan-vendor-card',
    imports: [MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatTooltip],
    templateUrl: './ia-market-scan-vendor-card.component.html',
    styleUrl: './ia-market-scan-vendor-card.component.scss'
})
export class IaMarketScanVendorCardComponent {
    logo = input<string>('');
    label = input<string>('');
    description = input<string>('');
    hasAccess = input<boolean>(false);
    badgeText = input<string>('Available');
    clicked = output<void>();
}
